"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var Seo = function Seo(props) {
  var _props$pageContext, _seo$opengraphImage, _seo$opengraphImage2;

  if (!(props !== null && props !== void 0 && (_props$pageContext = props.pageContext) !== null && _props$pageContext !== void 0 && _props$pageContext.seo)) {
    return null;
  }

  var _props$pageContext2 = props.pageContext,
      seo = _props$pageContext2.seo,
      language = _props$pageContext2.language,
      translations = _props$pageContext2.translations,
      siteTitle = _props$pageContext2.siteTitle,
      location = props.location;
  return /*#__PURE__*/_react.default.createElement(_reactHelmet.default, {
    htmlAttributes: {
      lang: (language === null || language === void 0 ? void 0 : language.slug) || ''
    }
  }, /*#__PURE__*/_react.default.createElement("title", null, "".concat((0, _htmlReactParser.default)(seo.title || ''))), /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: "".concat((0, _htmlReactParser.default)(seo.metaDesc || ''))
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "robots",
    content: (seo === null || seo === void 0 ? void 0 : seo.metaRobotsNoindex) || 'index'
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:description",
    content: "".concat((0, _htmlReactParser.default)(seo.metaDesc || ''))
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:type",
    content: "website"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image",
    content: ((_seo$opengraphImage = seo.opengraphImage) === null || _seo$opengraphImage === void 0 ? void 0 : _seo$opengraphImage.sourceUrl) || ''
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:site_name",
    content: "".concat((0, _htmlReactParser.default)(siteTitle || ''))
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:title",
    content: "".concat((0, _htmlReactParser.default)(seo.title || ''))
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "twitter:card",
    content: "summary"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "twitter:image",
    content: ((_seo$opengraphImage2 = seo.opengraphImage) === null || _seo$opengraphImage2 === void 0 ? void 0 : _seo$opengraphImage2.sourceUrl) || ''
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "twitter:title",
    content: "".concat((0, _htmlReactParser.default)(seo.title || ''))
  }), language !== null && language !== void 0 && language.locale ? /*#__PURE__*/_react.default.createElement("link", {
    rel: "alternate",
    href: location.href,
    hrefLang: language.locale.replace('_', '-').toLowerCase()
  }) : /*#__PURE__*/_react.default.createElement("link", {
    rel: "alternate",
    href: location.href,
    hrefLang: "x-default"
  }), translations && translations.map(function (o, i) {
    var _o$language, _o$language$locale;

    return /*#__PURE__*/_react.default.createElement("link", {
      key: i,
      rel: "alternate",
      href: o.uri,
      hrefLang: (_o$language = o.language) === null || _o$language === void 0 ? void 0 : (_o$language$locale = _o$language.locale) === null || _o$language$locale === void 0 ? void 0 : _o$language$locale.replace('_', '-').toLowerCase()
    });
  }));
};

var _default = Seo;
exports.default = _default;